import { render } from "./productOrderPosition.vue?vue&type=template&id=7d9c4c04"
import script from "./productOrderPosition.vue?vue&type=script&lang=js"
export * from "./productOrderPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__